export type DeferredInstallPrompt = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

type InstallWindow = Window & {
  __IRAQ_GOLD_DEFERRED_INSTALL_PROMPT__?: DeferredInstallPrompt;
};

const installWindow = () => window as InstallWindow;

export function captureDeferredInstallPrompt(event: Event): DeferredInstallPrompt {
  event.preventDefault();
  const prompt = event as DeferredInstallPrompt;
  installWindow().__IRAQ_GOLD_DEFERRED_INSTALL_PROMPT__ = prompt;
  window.dispatchEvent(new Event("iraq-gold-install-available"));
  return prompt;
}

export function getDeferredInstallPrompt(): DeferredInstallPrompt | null {
  return installWindow().__IRAQ_GOLD_DEFERRED_INSTALL_PROMPT__ ?? null;
}

export function clearDeferredInstallPrompt() {
  delete installWindow().__IRAQ_GOLD_DEFERRED_INSTALL_PROMPT__;
}
